import React from "react";
import DropDownFormList from "~v2/components/DropDownFormList/DropdownFormList";
import { filteringCountry } from "../../../helpers/filterCountry";

const Index = () => {
  const filteredCountry = filteringCountry();

  return (
    <>
      <DropDownFormList
        formListName="nonPhResident"
        dropdownTitle="Select Country of Residence"
        dropdownList={filteredCountry}
        dropdownName="country"
        dropdownRuleMessage="Please select a country!"
        inputFields={[
          { name: "male", message: "Please input number of male" },
          { name: "female", message: "Please input number of female" },
        ]}
      />
    </>
  );
};

export default Index;
